module.exports = __webpack_public_path__ + "static/media/Gold.d0c33f03.png";